import React, { Component } from 'react'
import { Radio } from 'hljd'
import style from './style.module.less'
import ContactModal from './ContactModal'
import SignModal from './SignModal'
import TaskModal from './TaskModal'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import {
  TAB_UPDATE_RECORD,
  TAB_CONTACT,
  TAB_SIGN,
  TAB_TASK
} from '@components/JiaMeng/NewCustomer/constant'
import ConfirmTaskModal from './ConfirmTaskModal'
import PaymentModal from './PaymentModal'
import InsertContractModal from './InsertContractModal'
import ApplyDeductFeeModal from './ApplyDeductFeeModal'
import ApplyReturnFeeModal from './ApplyReturnFeeModal'

@observer
class Index extends Component {
  render() {
    const { store } = this.props
    const propertyList = toJS(store.propertyList) || []

    return (
      <div className={style['right-edit-wrap']}>
        <Radio.Group
          value={store.type}
          onChange={e => {
            store.setStoreData([{ type: 'type', value: e.target.value }])
            store.getCardList()
          }}
          buttonStyle="solid"
        >
          <Radio.Button value={TAB_UPDATE_RECORD}>更新记录</Radio.Button>
          <Radio.Button value={TAB_CONTACT}>联系</Radio.Button>
          <Radio.Button value={TAB_SIGN}>签单</Radio.Button>
          <Radio.Button value={TAB_TASK}>任务</Radio.Button>
        </Radio.Group>

        <ContactModal store={store} />
        <SignModal store={store} propertyList={propertyList} />
        <TaskModal store={store} />
        <ConfirmTaskModal store={store} />
        <PaymentModal store={store} />
        <InsertContractModal store={store} />
        <ApplyDeductFeeModal store={store} />
        <ApplyReturnFeeModal store={store} />
      </div>
    )
  }
}

export default Index
